import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/authActions";
import type { State } from "../redux/authReducer";

const NavBar = () => {
  const navigation = useLocation();
  const dispatch = useDispatch();
  const currentUser = useSelector((state: State) => state.currentUser);

  const handleLogout = () => {
    dispatch(logout());
  };

  const isAdmin = currentUser?.userType === "Admin";

  return (
    <Navbar
      variant="light"
      bg="light"
      expand="md"
      // className="fw-semibold text-uppercase"
      className="fw-semibold"
    >
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <img
            src="/dedrone-logo.svg"
            alt="DedroneDefender Logo"
            style={{
              colorScheme: "light", // Override dark mode style for current white background
            }}
            width={26}
            height={26}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav variant="underline" className="me-auto">
            {isAdmin ? (
              <>
                <Nav.Item>
                  <Nav.Link as={Link} to="/admin-home">
                    Admin Home
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/admin-home/users/new">
                    Create User
                  </Nav.Link>
                </Nav.Item>
              </>
            ) : (
              <>
                <Nav.Item>
                  <Nav.Link as={Link} to="/user-home">
                    User Home
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/admin-home/app-versions">
                    App Versions
                  </Nav.Link>
                </Nav.Item>
              </>
            )}
          </Nav>
          {currentUser ? (
            <Nav>
              {/* <Nav.Link eventKey={2} href="#memes">
                    {currentUser?.id}
                  </Nav.Link> */}
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/"
                  onClick={handleLogout}
                  className="justify-self-end"
                >
                  Logout
                </Nav.Link>
              </Nav.Item>
            </Nav>
          ) : (
            <Nav>
              {/* <Nav.Link eventKey={2} href="#memes">
                    {currentUser?.id}
                  </Nav.Link> */}
              {navigation.pathname !== "/" && (
                <Nav.Item>
                  <Nav.Link as={Link} to="/" className="justify-self-end">
                    Login
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
